import React from 'react';
import { useTranslation } from 'react-i18next';

interface LeaveStatusBadgeProps {
  status: 'pending' | 'approved' | 'rejected';
  text?: string;
}

const LeaveStatusBadge: React.FC<LeaveStatusBadgeProps> = ({ status, text }) => {
  const { t } = useTranslation();

  const getBadgeStatus = () => {
    switch (status) {
      case 'approved':
        return 'success';
      case 'pending':
        return 'warning';
      case 'rejected':
        return 'danger';
      default:
        return 'secondary';
    }
  };

  const getDefaultText = () => {
    switch (status) {
      case 'approved':
        return t('leave.status.approved'); // ex: "Approuvé"
      case 'pending':
        return t('leave.status.pending'); // ex: "En attente"
      case 'rejected':
        return t('leave.status.rejected'); // ex: "Rejeté"
      default:
        return t('unknown');
    }
  };

  return (
    <span className={`badge badge-soft-${getBadgeStatus()} d-inline-flex align-items-center`}>
      <i className="ti ti-circle-filled fs-5 me-1"></i>
      {text || getDefaultText()}
    </span>
  );
};

export default LeaveStatusBadge;
